<template>
  <audio
    type="audio/mpeg"
    ref="sound"
    allow="autoplay"
    preload="auto"
    :loop="isLoop"
    :src="source"
  />
</template>
<script>
import { AlarmSound } from '@/js/plugin';
import { SOUNDLIST, SOUND_REPEAT, getBit } from '@/js/utils';
import Logger from '@/js/logger';

export default {
  name: 'AlarmAudio',
  data() {
    return {
      isPlaying: false,
      lastAlarmed: [],
    };
  },
  computed: {
    allowAccess() {
      return this.$store.getters['local/enableSound'];
    },
    source() {
      const src = SOUNDLIST.find(
        (file) => file.value === this.$store.getters['user/soundId']
      );
      return src ? src.file : SOUNDLIST[0].file;
    },
    activeAlarms() {
      return this.$store.getters['mqtt/alarmState']();
    },
    isLoop() {
      return getBit(this.$store.getters['user/userPreferences'], SOUND_REPEAT);
    },
  },
  methods: {
    enableSound() {
      const canPlay = this.$refs.sound.canPlayType('audio/mp3');
      Logger.info({ canPlay });
      const playing = this.$refs.sound.play();
      if (canPlay && playing) {
        playing.then(
          () => {
            this.$toast.showInfo({ content: [this.$t('DIALOG.str64')] });
            this.$store.dispatch('local/setEnableSound', true);
          },
          () => {
            this.$toast.showWarning({ content: this.$t('DIALOG.str66') });
            this.disableSound(true);
          }
        );
        this.$refs.sound.pause();
      } else {
        if (!playing) {
          this.$toast.showWarning({ content: this.$t('DIALOG.str73') });
          this.$store.dispatch('local/setEnableSound', true);
          this.$refs.sound.pause();
        } else {
          this.$toast.showWarning({ content: this.$t('DIALOG.str48') });
          this.disableSound(true);
        }
      }
    },
    disableSound(noAdditionalWarning) {
      this.$refs.sound.pause();

      this.isPlaying = false;
      if (!noAdditionalWarning) {
        this.$toast.showInfo({ content: [this.$t('DIALOG.str65')] });
      }
      this.$store.dispatch('local/setEnableSound', false);
    },
    toggleSound(isEnabled) {
      if (isEnabled) {
        this.enableSound();
      } else {
        this.disableSound();
      }
    },
    play(isForce) {
      if (!this.allowAccess) return;
      if (this.$refs.sound && (!this.isPlaying || isForce)) {
        this.$refs.sound.pause();
        this.$refs.sound.currentTime = 0;
        this.isPlaying = true;
        this.$refs.sound.onended = () => {
          if (!this.isLoop) this.isPlaying = false;
        };
        this.$refs.sound.play();
      }
    },
    stop() {
      this.$refs.sound.onended = null;
      this.$refs.sound.pause();
      this.$refs.sound.currentTime = 0;
      this.isPlaying = false;
    },
  },
  watch: {
    activeAlarms: {
      deep: true,
      handler() {
        if (
          this.activeAlarms.find(
            (al) => !this.lastAlarmed.find((el) => el.event_id === al.event_id)
          )
        ) {
          this.play(true);
        } else if (!this.activeAlarms.length) {
          this.stop();
        }
        this.lastAlarmed = this.activeAlarms.slice();
      },
    },
  },
  mounted() {
    AlarmSound.EventBus.$on('set', this.toggleSound);
  },
  beforeDestroy() {
    if (this.$refs.sound) this.$refs.sound.onended = null;
    AlarmSound.EventBus.$off();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
audio {
  display: none;
}
</style>
